export const listUserPopupAnswerssBasic = /* GraphQL */ `
  query ListUserPopupAnswerss(
    $filter: ModelUserPopupAnswersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPopupAnswerss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        popupId
        username
      }
      nextToken
    }
  }
`
